import React, { Component } from "react";

import cssstyles from "./styles.module.scss";
import navRoutes from "Navigation/NavRoutes";
import styles from "./styles";

class Footer extends Component {

  handleNavigation = () => this.props.history.push(navRoutes.contactUs)

  render() {
    return (
      <div style={styles.container} className={cssstyles.container}>
        <div style={styles.textContainer}>
          <p style={styles.text} onClick={this.handleNavigation}>Contact Us</p>
        </div>
      </div>
    );
  }
}

export default Footer;
